
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 6.5.0
 * Query Engine version: 173f8d54f8d52e692c7e27e72a88314ec7aeff60
 */
Prisma.prismaVersion = {
  client: "6.5.0",
  engine: "173f8d54f8d52e692c7e27e72a88314ec7aeff60"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.EmailLogScalarFieldEnum = {
  id: 'id',
  time: 'time',
  email: 'email',
  error: 'error',
  previewUrl: 'previewUrl',
  messageId: 'messageId',
  status: 'status'
};

exports.Prisma.UserPreferencesScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  workspaceId: 'workspaceId',
  scope: 'scope',
  preferences: 'preferences'
};

exports.Prisma.UserProfileScalarFieldEnum = {
  id: 'id',
  name: 'name',
  email: 'email',
  admin: 'admin',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  loginProvider: 'loginProvider',
  externalUsername: 'externalUsername',
  externalId: 'externalId'
};

exports.Prisma.UserPasswordScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  hash: 'hash',
  changeAtNextLogin: 'changeAtNextLogin'
};

exports.Prisma.WorkspaceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  deleted: 'deleted',
  slug: 'slug',
  featuresEnabled: 'featuresEnabled'
};

exports.Prisma.WorkspaceOptionsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  workspaceId: 'workspaceId',
  namespace: 'namespace',
  value: 'value'
};

exports.Prisma.WorkspaceAccessScalarFieldEnum = {
  workspaceId: 'workspaceId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  role: 'role'
};

exports.Prisma.WorkspaceUserPropertiesScalarFieldEnum = {
  workspaceId: 'workspaceId',
  userId: 'userId',
  lastUsed: 'lastUsed'
};

exports.Prisma.UserApiTokenScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  lastUsed: 'lastUsed',
  hint: 'hint',
  hash: 'hash',
  userId: 'userId'
};

exports.Prisma.InvitationTokenScalarFieldEnum = {
  id: 'id',
  workspaceId: 'workspaceId',
  email: 'email',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  token: 'token',
  usedBy: 'usedBy',
  role: 'role'
};

exports.Prisma.ConfigurationObjectScalarFieldEnum = {
  id: 'id',
  deleted: 'deleted',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  workspaceId: 'workspaceId',
  config: 'config'
};

exports.Prisma.ConfigurationObjectLinkScalarFieldEnum = {
  id: 'id',
  deleted: 'deleted',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  data: 'data',
  workspaceId: 'workspaceId',
  fromId: 'fromId',
  toId: 'toId'
};

exports.Prisma.ConnectorPackageScalarFieldEnum = {
  id: 'id',
  packageId: 'packageId',
  packageType: 'packageType',
  meta: 'meta',
  logoSvg: 'logoSvg',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AuditLogScalarFieldEnum = {
  id: 'id',
  timestamp: 'timestamp',
  type: 'type',
  userId: 'userId',
  workspaceId: 'workspaceId',
  objectId: 'objectId',
  changes: 'changes'
};

exports.Prisma.GlobalPropsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  value: 'value'
};

exports.Prisma.Source_specScalarFieldEnum = {
  package: 'package',
  version: 'version',
  specs: 'specs',
  timestamp: 'timestamp',
  error: 'error'
};

exports.Prisma.Source_checkScalarFieldEnum = {
  package: 'package',
  version: 'version',
  key: 'key',
  status: 'status',
  description: 'description',
  timestamp: 'timestamp'
};

exports.Prisma.Source_catalogScalarFieldEnum = {
  package: 'package',
  version: 'version',
  key: 'key',
  catalog: 'catalog',
  timestamp: 'timestamp',
  status: 'status',
  description: 'description'
};

exports.Prisma.Source_stateScalarFieldEnum = {
  sync_id: 'sync_id',
  stream: 'stream',
  state: 'state',
  timestamp: 'timestamp'
};

exports.Prisma.Source_taskScalarFieldEnum = {
  sync_id: 'sync_id',
  task_id: 'task_id',
  package: 'package',
  version: 'version',
  started_at: 'started_at',
  updated_at: 'updated_at',
  started_by: 'started_by',
  status: 'status',
  description: 'description',
  metrics: 'metrics',
  error: 'error'
};

exports.Prisma.Task_logScalarFieldEnum = {
  id: 'id',
  level: 'level',
  logger: 'logger',
  message: 'message',
  sync_id: 'sync_id',
  task_id: 'task_id',
  timestamp: 'timestamp'
};

exports.Prisma.ProfileBuilderScalarFieldEnum = {
  id: 'id',
  name: 'name',
  deleted: 'deleted',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  workspaceId: 'workspaceId',
  intermediateStorageCredentials: 'intermediateStorageCredentials',
  destinationId: 'destinationId',
  connectionOptions: 'connectionOptions',
  version: 'version'
};

exports.Prisma.ProfileBuilderFunctionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  profileBuilderId: 'profileBuilderId',
  functionId: 'functionId'
};

exports.Prisma.ProfileBuilderStateScalarFieldEnum = {
  profileBuilderId: 'profileBuilderId',
  profileBuilderVersion: 'profileBuilderVersion',
  instanceIndex: 'instanceIndex',
  totalInstances: 'totalInstances',
  startedAt: 'startedAt',
  updatedAt: 'updatedAt',
  lastTimestamp: 'lastTimestamp',
  processedUsers: 'processedUsers',
  totalUsers: 'totalUsers',
  errorUsers: 'errorUsers',
  speed: 'speed'
};

exports.Prisma.ProfileBuilderState2ScalarFieldEnum = {
  profileBuilderId: 'profileBuilderId',
  updatedAt: 'updatedAt',
  fullRebuildInfo: 'fullRebuildInfo',
  queuesInfo: 'queuesInfo',
  metrics: 'metrics'
};

exports.Prisma.StatusChangeScalarFieldEnum = {
  id: 'id',
  workspaceId: 'workspaceId',
  actorId: 'actorId',
  tableName: 'tableName',
  timestamp: 'timestamp',
  status: 'status',
  startedAt: 'startedAt',
  counts: 'counts',
  description: 'description',
  queueSize: 'queueSize'
};

exports.Prisma.NotificationStateScalarFieldEnum = {
  workspaceId: 'workspaceId',
  actorId: 'actorId',
  tableName: 'tableName',
  channelId: 'channelId',
  flappingSince: 'flappingSince',
  lastNotification: 'lastNotification',
  statusChangeId: 'statusChangeId',
  error: 'error'
};

exports.Prisma.NotificationScalarFieldEnum = {
  id: 'id',
  workspaceId: 'workspaceId',
  actorId: 'actorId',
  tableName: 'tableName',
  channelId: 'channelId',
  statusChangeId: 'statusChangeId',
  timestamp: 'timestamp',
  status: 'status',
  error: 'error'
};

exports.Prisma.OidcProviderScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  issuer: 'issuer',
  clientId: 'clientId',
  clientSecret: 'clientSecret',
  authorizationEndpoint: 'authorizationEndpoint',
  tokenEndpoint: 'tokenEndpoint',
  userinfoEndpoint: 'userinfoEndpoint',
  jwksUri: 'jwksUri',
  introspectionEndpoint: 'introspectionEndpoint',
  scopes: 'scopes',
  audience: 'audience',
  prompt: 'prompt',
  usernameClaim: 'usernameClaim',
  emailClaim: 'emailClaim',
  nameClaim: 'nameClaim',
  groupClaim: 'groupClaim',
  enabled: 'enabled',
  autoDiscovery: 'autoDiscovery'
};

exports.Prisma.OidcLoginGroupScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  workspaceId: 'workspaceId',
  oidcProviderId: 'oidcProviderId',
  groupValue: 'groupValue',
  allowAllUsers: 'allowAllUsers'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};
exports.WorkspaceRole = exports.$Enums.WorkspaceRole = {
  owner: 'owner',
  editor: 'editor',
  analyst: 'analyst'
};

exports.Prisma.ModelName = {
  EmailLog: 'EmailLog',
  UserPreferences: 'UserPreferences',
  UserProfile: 'UserProfile',
  UserPassword: 'UserPassword',
  Workspace: 'Workspace',
  WorkspaceOptions: 'WorkspaceOptions',
  WorkspaceAccess: 'WorkspaceAccess',
  WorkspaceUserProperties: 'WorkspaceUserProperties',
  UserApiToken: 'UserApiToken',
  InvitationToken: 'InvitationToken',
  ConfigurationObject: 'ConfigurationObject',
  ConfigurationObjectLink: 'ConfigurationObjectLink',
  ConnectorPackage: 'ConnectorPackage',
  AuditLog: 'AuditLog',
  GlobalProps: 'GlobalProps',
  source_spec: 'source_spec',
  source_check: 'source_check',
  source_catalog: 'source_catalog',
  source_state: 'source_state',
  source_task: 'source_task',
  task_log: 'task_log',
  ProfileBuilder: 'ProfileBuilder',
  ProfileBuilderFunction: 'ProfileBuilderFunction',
  ProfileBuilderState: 'ProfileBuilderState',
  ProfileBuilderState2: 'ProfileBuilderState2',
  StatusChange: 'StatusChange',
  NotificationState: 'NotificationState',
  Notification: 'Notification',
  OidcProvider: 'OidcProvider',
  OidcLoginGroup: 'OidcLoginGroup'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
